// utils/eventBus.js
import mitt from 'mitt';
export const eventBus = mitt();